module.exports = __webpack_public_path__ + "media/components/images/panels/6-b-30a64b54000c40468efcd1508789ceae.jpeg";